export enum MultiPicklistUpdateMode {
  Add = 1,
  Replace = 2,
  Remove = 3,
  Clear = 4,
}
